'use client'
import AuthPageClient from '@/components/AuthPage.client'

interface RegistrerenPageClientProps {
  prefillEmail?: string
  redirectPath?: string
  flags: { magicLinks: boolean; googleSignIn: boolean }
  googleClientId: string
  ctaText?: string
  intent?: string
}

export default function RegistrerenPageClient({
  prefillEmail,
  redirectPath,
  flags,
  googleClientId,
  ctaText,
  intent,
}: RegistrerenPageClientProps) {
  return (
    <AuthPageClient
      mode="register"
      prefillEmail={prefillEmail}
      redirectPath={redirectPath}
      flags={flags}
      googleClientId={googleClientId}
      ctaText={ctaText}
      intent={intent}
    />
  )
}
